import { /*nextTick,*/ isRef } from 'vue';
import { createI18n }      from 'vue-i18n';

function isComposer( instance, mode )
{
    return mode === 'composition' && isRef( instance.locale );
}

export function hasDictionary( i18n, locale )
{
    return i18n.global.availableLocales.includes( locale );
}

export async function loadDictionary( i18n, locale )
{
    await loadLocaleMessages( i18n, locale );

    setI18nLanguage( i18n, locale );
}

export function getLocale( i18n )
{
    return isComposer( i18n.global, i18n.mode ) ? i18n.global.locale.value : i18n.global.locale;
}

export function setLocale( i18n, locale )
{
    return isComposer( i18n.global, i18n.mode ) ? i18n.global.locale.value = locale : i18n.global.locale = locale;
}

export async function setupI18n( options = { locale: 'en' } )
{
    const i18n = createI18n( options );

    await loadLocaleMessages( i18n, options.locale );

    setI18nLanguage( i18n, options.locale );

    return i18n;
}

export function setI18nLanguage( i18n, locale )
{
    setLocale( i18n, locale )

    /**
    * NOTE:
    * If you need to specify the language setting for headers, such as the `fetch` API, set it here.
    * The following is an example for axios.
    *
    * axios.defaults.headers.common['Accept-Language'] = locale
    */

    document.querySelector('html').setAttribute('lang', locale );
}


export async function loadLocaleMessages( i18n, locale )
{
    // Use import.meta.glob to load all locale files (static pattern)
    const localeFiles = import.meta.glob('./locales/*-*.json');

    // Create an array of promises for importing only files matching the `-${locale}.json` pattern
    const localeImports = Object.entries(localeFiles)
        .filter(([path]) => path.includes(`-${locale}.json`))
        .map(([_, fileImport]) => fileImport().then((module) => module.default || module));

    // Wait for all imports to resolve
    const messages = await Promise.all(localeImports);

    // Map them to the corresponding file names for setting in i18n
    const messageNames = Object.entries(localeFiles)
        .filter(([path]) => path.includes(`-${locale}.json`))
        .reduce((acc, [path], index) =>
        {
            const key = path.split('/').pop().replace(`-${locale}.json`, '');
            acc[key] = messages[index];
            return acc;
        }, {});

    // Set the messages in i18n
    i18n.global.setLocaleMessage( locale, messageNames);

    //return nextTick();
}
